let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lH0NU")).then(() => parcelRequire('jKge3'));